import { FrontendFieldDefinition } from "src/modules/sm-base/models/frontend-field-definition.model";
import { FrontendFieldListItem } from "src/modules/sm-base/models/frontend-field-list-item.model";
import { FrontendFieldType } from "src/modules/sm-base/models/frontend-field-type.enum";
import { TableCellType } from "src/modules/sm-base/models/table-cell-type.enum";
import { TableColumn } from "src/modules/sm-base/models/table-column.model";
import { Utils } from "src/modules/utils/shared/utils";
import { EnaioGuiFieldListItem } from "../shared/EnaioGuiFieldListItem";
import { EnaioGuiFieldTableColumn } from "../shared/EnaioGuiFieldTableColumn";
import { EnaioTableDataType } from "../shared/EnaioTableDataType";
import { EnaioWorkflowDataMember } from "../shared/EnaioWorkflowDataMember";

export class EnaioUtils {

    static CLIENT_ID_ENAIO = "DB928B6631304CFC8D30B1B4FE67679B";
    static CLIENT_ID_ENAIO_WEB = "D4C24904B784420C922B66E012624D42";

    static CLIENT_ID_ENAIO_FRENCH = "DB928B6631304CFC8D30B1B4FE676888";
    static CLIENT_ID_ENAIO_ENGLISH = "DB928B6631304CFC8D30B1B4FE676999";

    static CLIENT_ID_ENAIO_WEB_FRENCH = "D4C24904B784420C922B66E012624888";
    static CLIENT_ID_ENAIO_WEB_ENGLISH = "D4C24904B784420C922B66E012624999";

    static CLIENT_ID_ENAIO_MOBILE = "4386E0A06D4141C6B3CC367B8A7B7C9F";
    static CLIENT_ID_ENAIO_USER_DEFINED = "B0EAA69765BC4689B954439C4B2D3EAF";

    static CLIENT_ID_SERVER = "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF";

    static getClientTypeName(clientTypeId: string): string {
        switch (clientTypeId) {
            case EnaioUtils.CLIENT_ID_ENAIO:
                return "";
            case EnaioUtils.CLIENT_ID_ENAIO_WEB:
                return "WebClient";
            case EnaioUtils.CLIENT_ID_ENAIO_FRENCH:
                return "[Französisch]";
            case EnaioUtils.CLIENT_ID_ENAIO_ENGLISH:
                return "[Englisch]";
            case EnaioUtils.CLIENT_ID_ENAIO_WEB_FRENCH:
                return "WebClient [Französisch]";
            case EnaioUtils.CLIENT_ID_ENAIO_WEB_ENGLISH:
                return "WebClient [Englisch]";
            case EnaioUtils.CLIENT_ID_ENAIO_MOBILE:
                return "Mobil";
            case EnaioUtils.CLIENT_ID_ENAIO_USER_DEFINED:
                return "Benutzerdefiniert";
            case EnaioUtils.CLIENT_ID_SERVER:
                return "Server";
            default:
                return clientTypeId;
        }
    }

    static getLanguageByClientType(clientTypeId: string): string {
        switch (clientTypeId) {
            case EnaioUtils.CLIENT_ID_ENAIO:
            case EnaioUtils.CLIENT_ID_ENAIO_USER_DEFINED:
            case EnaioUtils.CLIENT_ID_SERVER:
                 return "vbscript";
            case EnaioUtils.CLIENT_ID_ENAIO_FRENCH:
            case EnaioUtils.CLIENT_ID_ENAIO_ENGLISH:
            case EnaioUtils.CLIENT_ID_ENAIO_WEB_FRENCH:
            case EnaioUtils.CLIENT_ID_ENAIO_WEB_ENGLISH:
            case EnaioUtils.CLIENT_ID_ENAIO_MOBILE:
            case EnaioUtils.CLIENT_ID_ENAIO_WEB:
                return "javascript";
            default:
                return "";
        }
    }

    static isClientTypeRelevant(clientTypeId: string): boolean {
        return clientTypeId == EnaioUtils.CLIENT_ID_ENAIO || clientTypeId == EnaioUtils.CLIENT_ID_ENAIO_WEB || clientTypeId == EnaioUtils.CLIENT_ID_SERVER;
    }

    static guiFieldListItemToFrontend(enaioItem: EnaioGuiFieldListItem, useItemValue: boolean, translated?: string): FrontendFieldListItem {
        return new FrontendFieldListItem(useItemValue ? enaioItem.value : enaioItem.text, translated ?? enaioItem.text);
    }

    static guiFieldTableColumnToFrontend(frontendField: FrontendFieldDefinition, enaioItem: EnaioGuiFieldTableColumn, recordMember: EnaioWorkflowDataMember, fullWidth: number, allColsWidth): TableColumn {
        return new TableColumn(
            recordMember != null ? recordMember.name : enaioItem.name,
            enaioItem != null ? enaioItem.name : recordMember.name,
            enaioItem?.type == EnaioTableDataType.date ? TableCellType.date :
            enaioItem?.type == EnaioTableDataType.number ? TableCellType.int :
            enaioItem?.type == EnaioTableDataType.decimal ? TableCellType.decimal :
            TableCellType.text,
            {
                autoWidth: (enaioItem != null ? enaioItem.colWidth * fullWidth / allColsWidth : 50) / 8,
                editable: enaioItem == null || !enaioItem?.readOnly,
                sortable: false,
                resizable: false, 
                editableMaxLength: enaioItem?.length,
                getStyleClassCallback: event => frontendField.getCellStyleClass(event.value, event.rowIndex, event.columnIndex),
                editableCallback: event => frontendField.isTableCellEnabled(event.rowIndex, event.columnIndex),
                toolTipGetter: event => frontendField.getCellErrorMessage(event.rowIndex, event.columnIndex),
                editor: Utils.isNoe(enaioItem?.listItems) ? null : new FrontendFieldDefinition("field", "Feld", FrontendFieldType.comboBox, { 
                    dropdownEditable: false, 
                    listItems: [new FrontendFieldListItem("", ""), ...enaioItem.listItems.map(li => new FrontendFieldListItem(li, Utils.toString(li)))] 
                })
            });
    }
}
